import React, { useEffect } from "react"
import FooterComponent from "../../components/footer"
import ReactHelmet from "../../components/react-helmet"

const RentalApplication = () => {
  useEffect(() => {
    try {
      var script = document.createElement("script")
      script.src = "https://paperform.co/__embed"
      script.async = true
      document.body.appendChild(script)
    } catch (error) {
      console.error(error)
    }
  }, [])

  return (
    <>
      <ReactHelmet
        url="rental-application"
        title={`Tolobi Rental`}
        description="Tolobi - Rental Made Easy"
        id=""
        city=""
      />
      <div data-paperform-id="tolobi-rental-app"></div>
      <FooterComponent />
    </>
  )
}

export default RentalApplication
